import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../../_helper/Customizer";
import {
  Infrastructures,
  Comment,
  LinkType,
  LinkStatuses,
  Product,
  Customer,
  CustomerBranch,
  PoPInfo,
  ProductInfo,
  Pop,
  Zone,
  Region,
  LocationType,
  Location,
  ProductType,
  ProductClass,
  ProductGroup,
} from "../../../../../../Constant";

import { toast } from "react-toastify";
import useAuth from "../../../../../../Hooks/useAuth";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import { CustomerApi, CustomerBranchApi, InfrastructureApi, LinkApi, LinkStatusApi, LinkTypeApi, LocationDropdownApi, LocationTypeApi, OrgZoneApi, ProductApi, ProductClassApi, ProductGroupApi, ProductTypeApi, RegionApi } from "../../../../../../api";
import { createDropdownField } from "../../../../../../Data/FormField/PublicData";

export default function useTechnicalLinkForm() {
  const axiosPrivate = useAxiosPrivate();
  const formTitle = `Link`;
  const { userOrganisationId }: any = useAuth();
  const orgZoneApi = OrgZoneApi(userOrganisationId);
  const regionApi = RegionApi(userOrganisationId);

  const [dateRange, setDateRange] = useState<Date[] | null[]>([null, null]);
  const [startDate, endDate] = dateRange;

  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "remark",
      name: "remark",
      label: Comment,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    }
  ]);
 
  const customerDropdownField = {
    name: "contact_id",
    id: "contact_number, company_name, last_name, first_name",
    api: `${CustomerApi}`,
    label: `${Customer}`,
    type: "input-select",
    value: "",
    colSize: 6,
    required: true,
    onSelectedChange : async function (selectedId: number, updatedFields: any) { 
      const cBField = updatedFields.find((field:any) => field.id === 'contact_branch_id');
      
      if (cBField) {
        const endPoint = `${CustomerBranchApi}?organisation_id=${userOrganisationId}&contact_id=${selectedId}`
        await cBField.fetchOptions(selectedId, false, endPoint);
        setFormFields([...updatedFields]);
      } 
    }
  };

  const customerBranchDropdownField = createDropdownField(
      axiosPrivate,
      "contact_branch_id",
      "contact_branch_id",
      CustomerBranch,
      "",
      "",
      6, false
  );

  const ZoneOrgDropdownField = createDropdownField(axiosPrivate,
    'zone_id',
    'zone_id',
    `${Zone}`,
    `${orgZoneApi}`,
    '',
    6
  );

  const RegionOrgDropdownField = createDropdownField(axiosPrivate,
    'region_id',
    'region_id',
    `${Region}`,
    ``,
    '',
    6
  );

  const LocationTypeDropdownField = createDropdownField(axiosPrivate,
    'location_type_id',
    'location_type_id',
    `${LocationType}`,
    ``,
    '',
    6
  );

  const LocationDropdownField = createDropdownField(axiosPrivate,
    'location_id',
    'location_id',
    `${Location}`,
    ``,
    '',
    6
  );

  ZoneOrgDropdownField.onChange = async (selectedZoneId, updatedFields) => { 
    const regionField = updatedFields.find((field: any) => field.id === 'region_id');
    
    if (regionField) {
      const endPoint = `${regionApi}?zone_id=${selectedZoneId}`
      await regionField.fetchOptions(selectedZoneId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  RegionOrgDropdownField.onChange = async (selectedRegionId, updatedFields) => { 
    const modelField = updatedFields.find((field: any) => field.id === 'location_type_id');
    
    if (modelField) {
      const endPoint = `${LocationTypeApi}?organisation_id=${userOrganisationId}`
      await modelField.fetchOptions(selectedRegionId, false, endPoint);
      setFormFields([...updatedFields]);
    }
  };

  LocationTypeDropdownField.onChange = async (selectedId, updatedFields) => { 
    const modelField = updatedFields.find((field: any) => field.id === 'location_id');
    
    if (modelField) {
      //region_id=${selectedRegionId}
      const endPoint = `${LocationDropdownApi(userOrganisationId)}?location_type_id=${selectedId}`
      await modelField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  const LinkTypeDropDown = createDropdownField(
      axiosPrivate,
      "link_type_id",
      "link_type_id",
      LinkType,
      `${LinkTypeApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  const LinkStatusDropDown = createDropdownField(
      axiosPrivate,
      "link_status_id",
      "link_status_id",
      LinkStatuses,
      `${LinkStatusApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  const InfrastructureDropDown = createDropdownField(
      axiosPrivate,
      "infrastructure_id",
      "infrastructure_id",
      Infrastructures,
      `${InfrastructureApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  const ProductGroupDropDown = createDropdownField(
    axiosPrivate,
    "product_group_id",
    "product_group_id",
    ProductGroup,
    `${ProductGroupApi}?organisation_id=${userOrganisationId}`,
    "",
    6
  );
  
  const ProductClassDropDown = createDropdownField(
    axiosPrivate,
    "product_class_id",
    "product_class_id",
    ProductClass,
    "",
    "",
    6
  );

  const ProductTypeDropDown = createDropdownField(
      axiosPrivate,
      "product_type_id",
      "product_type_id",
      ProductType,
      "",
      "",
      6
  );

  const ProductDropDown = createDropdownField(
      axiosPrivate,
      "product_id",
      "product_id",
      Product,
      "",
      "",
      6
  );

  ProductGroupDropDown.onChange = async (selectedId, updatedFields) => { 
    const targetField = updatedFields.find((field: any) => field.id === 'product_class_id');
    
    if (targetField) {
      const endPoint = `${ProductClassApi}?organisation_id=${userOrganisationId}&product_group_id=${selectedId}`
      await targetField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  ProductClassDropDown.onChange = async (selectedId, updatedFields) => { 
    const targetField = updatedFields.find((field: any) => field.id === 'product_type_id');
    
    if (targetField) {
      const endPoint = `${ProductTypeApi}?organisation_id=${userOrganisationId}&product_class_id=${selectedId}`
      await targetField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  ProductTypeDropDown.onChange = async (selectedId, updatedFields) => { 
    const targetField = updatedFields.find((field: any) => field.id === 'product_id');
    
    if (targetField) {
      const endPoint = `${ProductApi}?organisation_id=${userOrganisationId}&product_type_id=${selectedId}`
      await targetField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  // ?? Call on every dependent change
  async function updateFields() {
    const updatedFields = [
      customerDropdownField,
      customerBranchDropdownField,
      LinkTypeDropDown, 
      InfrastructureDropDown, 
      LinkStatusDropDown,
      {
        type: 'group-title',
        label: `${PoPInfo}`,
      },
      ZoneOrgDropdownField,
      RegionOrgDropdownField, 
      LocationTypeDropdownField,
      LocationDropdownField,
      {
        type: 'group-title',
        label: `${ProductInfo}`,
      },
      ProductGroupDropDown,
      ProductClassDropDown,
      ProductTypeDropDown,
      ProductDropDown, 
       
      ...formFields
    ];
    await LinkTypeDropDown.fetchOptions();
    await InfrastructureDropDown.fetchOptions();
    await LinkStatusDropDown.fetchOptions();
    await ZoneOrgDropdownField.fetchOptions();
    await ProductGroupDropDown.fetchOptions();
    setFormFields(updatedFields);
  }

  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    updateFields();
  }, []);

  const { layoutURL } = useContext(CustomizerContext);
  const backBtn = `${process.env.PUBLIC_URL}/technical/links/${layoutURL}`;

  const onSubmit = async (data: any) => {
    data.organisation_id = userOrganisationId;
    data.contact_branch_id = data.contact_branch_id ? data.contact_branch_id : null;
    
    data.link_technical_details = {
      location_id: data.location_id,
      link_type_id: data.link_type_id,
      link_status_id: data.link_status_id,
      device_id: data.device_id,
      infrastructure_id: data.infrastructure_id
    };

    await axiosPrivate
      .post(LinkApi, data)
      .then((_res) => {
        toast.success(`${_res.data.contact.contact_number} New Link Created Successfully.`);
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error("Validation Errors");
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
        throw err;
        //toast.error(err.response.message || "Whoops! Something went wrong");
      });
  };

  return { formTitle, formFields, backBtn, onSubmit };
}
